<template>
  <div
    class="page_container goodsManageSet"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manageCenterIndex/userManagement' }">业务管理</el-breadcrumb-item>
        <el-breadcrumb-item>积分消费规则管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!--  主要内容 start -->
    <div class="form_container">
      <h1>积分消费规则管理</h1>
      <div class="content_wrap flex-between">
        <div class="form_wrap">    
          <div class="block">
            <p><span class="mark">*</span>是否允许使用积分抵扣支付</p>
            <div class="radio_box">
              <el-radio-group
                v-model="formData.isallowscore"
              >
                <el-radio label="1">是</el-radio>
                <el-radio
                  label="0"
                  >否</el-radio
                >
              </el-radio-group>
            </div>
          </div>

          <div class="block">
            <p><span class="mark">*</span>是否限制抵扣额度</p>
            <div class="radio_box">
              <el-radio-group
                v-model="formData.lslimit"
              >
                <el-radio label="1">限制</el-radio>
                <el-radio
                  label="0"
                  >不限制</el-radio
                >
              </el-radio-group>
            </div>
          </div>

          <div class="block">
            <p><span class="mark">*</span>最大抵扣额度（数字输入项，仅支持整数数字）</p>
            <div class="input_box" style="margin-top: 15px">
              <el-input
                v-model="formData.maxdiscount"
                placeholder="请输入最大抵扣额度"
                type="digit"
              />
            </div>
          </div>
          

          
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="btn" @click="query">确认</div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>
    <!--  主要内容 end -->
  </div>
</template>

<script>
import { encryptstringview } from "../../api/api";
import {
  getConsumptionRule,
  addConsumptionRule,
  editConsumptionRule,
} from "../../api/company";
export default {
  name: "consumptionRule",
  data() {
    return {
      loading: false,
      id: '',  // 是否已提交数据
      formData: {
        qyguid: "",
        isallowscore: "",
        lslimit: "",
        maxdiscount: "",
      },
    };
  },
  computed: {
    isDisabled() {
      return (item) => {
        // 根据某些条件来判断是否禁用某个选项
        if (this.pernumCheck.includes(item.areaid)) {
          return true;
        }
        return false;
      };
    },
    isDisabled1() {
      return (item) => {
        // 根据某些条件来判断是否禁用某个选项
        if (this.ruleCheck.includes(item.areaid)) {
          return true;
        }
        return false;
      };
    },
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
     async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { qyguid } = JSON.parse(res.jsondata);
        this.formData.qyguid = qyguid;
        this.getConsumptionRule();
      } else {
        this.$router.back();
      }
    },

     // 获取消费规则
    getConsumptionRule() {
      let qyguid = this.formData.qyguid;
      getConsumptionRule({ qyguid }).then((res) => {
        this.id = res.id ? res.id : ''
        this.formData.isallowscore = res.isallowscore ? res.isallowscore : 0
        this.formData.lslimit = res.lslimit ? res.lslimit : 0
        this.formData.maxdiscount = res.maxdiscount
      });
    },

    query() {
      let { formData, id } = this;
      if (formData.isallowscore == "") {
        this.$message.warning("请选择是否允许使用积分抵扣支付");
        return;
      }
      if (formData.lslimit == "") {
        this.$message.warning("请选择是否限制抵扣额度");
        return;
      }
      if (formData.maxdiscount == "") {
        this.$message.warning("请输入最大抵扣额度");
        return;
      }
      this.loading = true;
      if (id != "") {
        editConsumptionRule(formData).then((res) => {
          if (res.result) {
            setTimeout(() => {
              this.loading = false;
              this.$router.back();
            }, 500);
          } else {
            this.loading = false;
            this.$message.error(res.message || "服务器报错，请稍后～");
          }
        });
      } else {
        addConsumptionRule(formData).then((res) => {
          if (res.result) {
            setTimeout(() => {
              this.loading = false;
              this.$router.back();
            }, 500);
          } else {
            this.loading = false;
            this.$message.error(res.message || "服务器报错，请稍后～");
          }
        });
      }
    },

    handleReturn() {
      history.back();
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  .form_container {
    .content_wrap {
      .form_wrap {
        margin-right: 100px;
      }
      .tip_wrap {
        flex: 1;
        .item {
          margin-bottom: 30px;
          color: #6e6e6e;
          h1 {
            margin-bottom: 8px;
            font-size: 18px;
          }
          p {
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>